import {configureStore} from './configure'

export const store = configureStore()
